import { Component, OnInit, ViewChild } from '@angular/core';

import { UtilityService, AuthService, AppInformationService, ArkUnitOfWork } from 'app/core/core.module';
import { Family, Person } from 'app/core/model/entity-model';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DevExtremeModule, DxDataGridComponent } from 'devextreme-angular';
import { confirm, alert } from 'devextreme/ui/dialog';
import moment from 'moment';
import { BsModalService } from 'ngx-bootstrap/modal';
import { FamiliesDetailComponent } from '../families-detail/families-detail.component';
import { VisitDetailComponent } from '../visit-detail/visit-detail.component';

@Component({
    selector: 'app-membership-overview',
    templateUrl: './membership-overview.component.html',
    styleUrls: ['./membership-overview.component.scss'],
    imports: [DevExtremeModule]
})
export class MembershipOverviewComponent implements OnInit {
    statuses: any;
    peopleStatuses: any;
    familyStatuses: any;
    filter: any;
    people: any[];
    givingYears: any;
    canPrintStatement = false;

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;

    constructor(
        private uow: ArkUnitOfWork,
        private utility: UtilityService,
        private auth: AuthService,
        private appInfo: AppInformationService,
        private modalService: BsModalService
    ) {}

    async ngOnInit() {
        const relationships = this.uow.lookups.relationships;
        this.peopleStatuses = this.uow.lookups.peopleStatuses;
        this.familyStatuses = this.uow.lookups.familyStatuses;
        this.statuses = this.uow.lookups.peopleStatuses.map((x) => {
            return { id: x.id, name: x.name, isActive: x.isActive };
        });
        this.statuses.splice(0, 0, { id: 1, name: 'All', isActive: false });
        this.filter = { statusId: this.statuses[0].id };
        await this.getData();
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async onValueChanged(e) {
        if (!this.filter.statusId) return;
        await this.getData();
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            // if (!e.data.days) e.rowElement.className = e.rowElement.className + ' visits-yellow-grid';
            if (!!e.data.days || e.data.days === 0) {
                if (e.data.days < 180) e.rowElement.className = e.rowElement.className + ' visits-green-grid';
                if (e.data.days >= 180 && e.data.days < 365) e.rowElement.className = e.rowElement.className + ' visits-yellow-grid';
                if (e.data.days >= 365) e.rowElement.className = e.rowElement.className + ' visits-red-grid';
            }
        }
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        const families = (await this.uow.getFamilies()) as Family[];

        this.people = (await this.uow.getMembersByStatus(this.filter.statusId)) as Person[];
        // this.families.forEach((family) => {
        //     if (!!family.lastVisit) family.lastVisit = moment(family.lastVisit).toDate();
        //     family.family = family.family as Family;
        //     const days = Math.floor(moment.duration(moment(new Date()).diff(family.lastVisit)).asDays());
        //     family.days = isNaN(days) ? null : days;
        // });
        this.appInfo.pleaseWaitHide();
    }

    async open(data: any) {
        const modalRef = this.modalService.show(FamiliesDetailComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                // family: data.family,
                key: data.familyId,
                showAsDialog: true,
            },
        });

        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                // await this.getData();
            }
            modalRef.hide();
        });
    }

    async getStatus(statuses: any[]): Promise<number> {
        const modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Update Status',
                dialogPrompt: 'Select Status',
                dialogValueArray: statuses,
                mode: 'selectWithId',
            },
        });

        const promise = new Promise<number>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value)
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;

    }

    async updateStatus(mode: any) {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;

        let statuses = null;
        if (mode === 'Person') statuses = this.uow.lookups.peopleStatuses;
        else if (mode === 'Family') statuses = this.uow.lookups.familyStatuses;

        const selectedStatus = await this.getStatus(statuses);
        if (!selectedStatus) return;
        this.appInfo.pleaseWaitShow();
        const array = selectedRows;
        for (let index = 0; index < array.length; index++) {
            if (mode === 'Person') {
                const person = (await this.uow.people.byId(array[index].id)) as Person;
                person.personStatusId = selectedStatus
            } else if (mode === 'Family') {
                const family = await this.uow.getAllFamilyById(array[index].familyId);
                family.familyStatusId = selectedStatus
            } else return;
        }

        await this.uow.commit();
        await this.getData();
        this.appInfo.pleaseWaitHide();
    }
}
